import { redirecionamentoGenerico } from './redirecionamento-generico'

const TARGET_URL = 'http://biblioteca-virtual.com/'

export const redirecionarParaBibliotecaVirtual = (
  abrindoNovaAba = true
): void => {
  redirecionamentoGenerico(TARGET_URL, abrindoNovaAba)
}
